<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCardHeader>
        <h5><b>Edit Game</b></h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="6">
                <label>Game Name</label>

                <CSelect v-model="GameName" :options="options" />
              </CCol>
              <CCol sm="6">
                <label>Participation Limit</label>
                <CInput
                  type="number"
                  placeholder="Participation Limit"
                  v-model="Limit"
                />
              </CCol>

              <CCol sm="6">
                <label>Pool Start Date </label>
                <CCard v-if="enablepicker">
                  <CCardHeader>
                    <span>{{ this.editstarttime }}</span>
                    <CButton
                      @click="changepicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>
                <VueCtkDateTimePicker v-model="Poolstarttime" v-else />
                <br />
              </CCol>

              <CCol sm="6">
                <label>Match End Date</label>
                <CCard v-if="enablepicker">
                  <CCardHeader>
                    <span>{{ this.editendtime }}</span>
                    <CButton
                      @click="changepicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>
                <VueCtkDateTimePicker v-model="PoolEndtime" v-else />
                <br />
              </CCol>
              <CCol sm="6">
                <label>Match Start Time</label>
                <CCard v-if="matchTimeEnablePicker">
                  <CCardHeader>
                    <span>{{ this.editMatchtime }}</span>
                    <CButton
                      @click="matchTimeChangePicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>
                <VueCtkDateTimePicker v-model="MatchStarttime" v-else />
                <br />
              </CCol>
              <CCol sm="6">
                <label>Prize</label>
                <CInput type="number" v-model="price" />
              </CCol>
              <CCol sm="6">
                <label>Room ID</label>
                <CInput v-model="roomID" />
              </CCol>
              <CCol sm="6" v-if="this.roomPassword != 'Ludo King'">
                <label>Room Password</label>
                <CInput v-model="roomPassword" />
              </CCol>
              <CCol sm="6">
                <label>Rage Entrance Price</label>
                <CInput v-model="rageEntrancePrice" type="number" />
              </CCol>
              <CCol sm="6">
                <label>PRage Entrance Price</label>
                <CInput v-model="PrageEntrancePrice" type="number" />
              </CCol>
              <CCol sm="12">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="3"><h5>Choose Field Type</h5> </CCol>
                      <CCol sm="5">
                        <input
                          type="radio"
                          style="width: 57px; height: 21px"
                          v-model="fieldtype"
                          value="RoomIDandPassword"
                        />&nbsp;<span style="font-size: 17px; font-weight: 500"
                          >RoomID and Password
                        </span>
                      </CCol>
                      <CCol sm="4">
                        <input
                          type="radio"
                          v-model="fieldtype"
                          value="RoomID"
                          style="width: 57px; height: 21px"
                        />&nbsp;<span style="font-size: 17px; font-weight: 500"
                          >RoomID</span
                        >
                      </CCol>
                    </CRow>
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="12">
                <p>Game Prize</p>
                <div
                  class="form-group"
                  v-for="(input, k) in this.gamePrize"
                  :key="k"
                >
                  <CRow>
                    <CCol sm="6">
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Game Prize"
                        v-model.number="gamePrize[k]"
                      />
                    </CCol>
                    <CCol sm="2">
                      <span>
                        <CButton
                          color="danger"
                          @click="removeGamePrize(k)"
                          v-show="k || (!k && gamePrize.length > 1)"
                        >
                          <i class="fa fa-times"></i
                        ></CButton>
                        &nbsp;&nbsp;&nbsp;
                        <CButton
                          color="success"
                          @click="addGamePrize()"
                          v-show="k == gamePrize.length - 1"
                        >
                          <i class="fa fa-plus" aria-hidden="true"></i
                        ></CButton>
                      </span>
                    </CCol>
                  </CRow>
                </div>
              </CCol>

              <CCol sm="12" style="text-align: center !important">
                <CButton
                  color="success"
                  style="width: 20%"
                  :disabled="isActive"
                  @click="saveGame()"
                  >Save</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import firebase from "firebase";
const db = firebase.firestore();
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Swal from "sweetalert2";
import moment from "moment";
export default {
  components: { VueCtkDateTimePicker },
  data() {
    return {
      isActive: false,
      GameName: "",
      Limit: 0,
      Poolstarttime: "",
      PoolEndtime: "",
      MatchStarttime: "",
      price: 0,
      roomPassword: "",
      roomID: "",
      id: "",
      enablepicker: false,
      editstarttime: "",
      editendtime: "",
      editMatchtime: "",
      matchTimeEnablePicker: false,
      isPoolUpdate: false,
      isMatchUpdate: false,
      options: [],
      rageEntrancePrice: 0,
      PrageEntrancePrice: 0,
      gamePrize: [0],
      infoEnableTime: "",
      fieldtype: "",
      isfield: true,
    };
  },
  watch: {},
  methods: {
    addGamePrize() {
      this.gamePrize.push(0);
    },
    removeGamePrize(index) {
      this.gamePrize.splice(index, 1);
    },
    GetgameName() {
      db.collection("esports")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            for (let i = 0; i < doc.data()["games"].length; i++) {
              this.options.push(doc.data()["games"][i].name);
            }
          });
        });
    },
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    GetDataByID() {
      db.collection("esportsGames")
        .doc(this.id)
        .get()
        .then((snapshot) => {
          this.GameName = snapshot.data().name;
          this.Limit = snapshot.data().participantLimit;
          this.price = snapshot.data().price;
          this.roomPassword = snapshot.data().roomPassword;
          this.roomID = snapshot.data().roomId;
          this.Poolstarttime = snapshot.data().startTime;
          this.PoolEndtime = snapshot.data().endTime;
          this.MatchStarttime = snapshot.data().matchStartTime;
          this.PrageEntrancePrice = snapshot.data().prageEntrancePrice;
          this.rageEntrancePrice = snapshot.data().rageEntrancePrice;
          this.gamePrize = snapshot.data().gamePrize;
          this.infoEnableTime = snapshot.data().infoEnableTime;
          this.isfield = snapshot.data().isfiled;
          this.editstarttime = moment(
            snapshot.data().startTime.seconds * 1000
          ).format("DD-MMM-YYYY, h:mm:ss a");

          this.editendtime = moment(
            snapshot.data().endTime.seconds * 1000
          ).format("DD-MMM-YYYY, h:mm:ss a");

          this.editMatchtime = moment(
            snapshot.data().matchStartTime.seconds * 1000
          ).format("DD-MMM-YYYY, h:mm:ss a");

          if (this.isfield) {
            this.fieldtype = "RoomIDandPassword";
          } else {
            this.fieldtype = "RoomID";
          }
          if (this.editstarttime != "Invalid date") {
            this.enablepicker = true;
            this.matchTimeEnablePicker = true;
          } else {
          }
        });
    },
    changepicker() {
      this.enablepicker = false;
      this.isPoolUpdate = true;
      this.Poolstarttime = "";
      this.PoolEndtime = "";
    },
    matchTimeChangePicker() {
      this.matchTimeEnablePicker = false;
      this.isMatchUpdate = true;
      this.MatchStarttime = "";
    },
    saveGame() {
      if (this.fieldtype == "RoomIDandPassword") {
        this.isfield = true;
      } else {
        this.isfield = false;
      }

      if (this.isPoolUpdate) {
        this.Poolstarttime = firebase.firestore.Timestamp.fromDate(
          new Date(this.Poolstarttime)
        );
        this.PoolEndtime = firebase.firestore.Timestamp.fromDate(
          new Date(this.PoolEndtime)
        );
      }
      if (this.isMatchUpdate) {
        this.infoEnableTime = new Date(this.MatchStarttime);
        this.infoEnableTime.setMinutes(this.infoEnableTime.getMinutes() - 15);

        this.MatchStarttime = firebase.firestore.Timestamp.fromDate(
          new Date(this.MatchStarttime)
        );
      }

      if (this.Limit <= 0) {
        this.showMessage("Please Enter a Limit", "warning");
      } else if (this.Poolstarttime == "") {
        this.showMessage("Pick a Start Time", "warning");
      } else if (this.PoolEndtime == "") {
        this.showMessage("Pick a End Time", "warning");
      } else if (this.MatchStarttime == "") {
        this.showMessage("Pick a Match Start Time", "warning");
      } else if (this.price <= 0) {
        this.showMessage("Please Enter a Valid prize", "warning");
      } else if (this.entryFees <= 0) {
        this.showMessage("Please Enter a Valid Fees", "warning");
      } else if (this.roomID == "") {
        this.showMessage("Please Enter a Room ID", "warning");
      } else if (this.roomPassword == "") {
        this.showMessage("Please Enter a Room Password", "warning");
      } else if (this.GameName == "") {
        this.showMessage("Please Select a Game", "warning");
      }
      // else if (this.PrageEntrancePrice <= 0) {
      //   this.showMessage("Please Enter a PRage Entrance Price", "warning");
      // }
      else if (this.gamePrize[this.gamePrize.length - 1] == 0) {
        this.showMessage(
          "Please Enter a Valid GamePrize or remove the excess Fields",
          "warning"
        );
      } else {
        this.isActive = true;
        db.collection("esportsGames")
          .doc(this.id)
          .update({
            name: this.GameName,
            participantLimit: parseInt(this.Limit),
            startTime: this.Poolstarttime,
            endTime: this.PoolEndtime,
            matchStartTime: this.MatchStarttime,
            price: parseInt(this.price),
            roomPassword: this.roomPassword,
            roomId: this.roomID,
            gameUploadDate: firebase.firestore.Timestamp.fromDate(new Date()),
            prageEntrancePrice: parseInt(this.PrageEntrancePrice),
            rageEntrancePrice: parseInt(this.rageEntrancePrice),
            gamePrize: this.gamePrize,
            infoEnableTime: this.infoEnableTime,
            isfiled: this.isfield,
          })
          .then(() => {
            this.GameName = "";
            this.Limit = 0;
            this.Poolstarttime = "";
            this.PoolEndtime = "";
            this.MatchStarttime = "";
            this.price = 0;
            this.roomPassword = "";
            this.roomID = "";
            this.entryFees = 0;
            this.id = "";
            this.enablepicker = false;
            this.editstarttime = "";
            this.editendtime = "";
            this.editMatchtime = "";
            this.matchTimeEnablePicker = false;
            this.isPoolUpdate = false;
            this.isMatchUpdate = false;
            this.prageEntrancePrice = 0;
            this.rageEntrancePrice = 0;
            this.gamePrize = [0];
            this.infoEnableTime = "";
            this.showMessage("Data Updated Successfully", "success");

            this.$router.push({ name: "esportsList" });
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.GetDataByID();
    this.GetgameName();
  },
};
</script>
